'use strict';

angular.module('mean.foreman').factory('foremanCalendarService', ['$filter', '$q', 'Holidays', 'userService',
    function($filter, $q, Holidays, userService) {
        var holidays = [];
        var dateFormat = 'yyyy-MM-dd';

        /* Get defined holidays in the system */
        var setHolidaysArray = function(username) {
            userService.getMainAccount(username).then(function(account) {
                Holidays.query({'main_account_id': account._id}, function(holiday_db) {
                    if(holiday_db.length === 1) {
                        _.each(holiday_db[0].entries, function(entry) {
                            holidays.push($filter('date')(entry.date, dateFormat));
                        });
                    }
                });
            });
        };

        var inRange = function(actual, expected) {
            return moment(actual).isSame(expected, 'day');
        }

        /* Disables Saturdays, Sundays, and Holidays */
        var disabled = function(date, mode) {
            if(mode === 'day') {
                if(holidays.indexOf($filter('date')(date, dateFormat)) !== -1) {
                    return 1;
                } 
            }
            return ( mode === 'day' && ( date.getDay() === 0 || date.getDay() === 6 ) );
        };

        var getValidDate = function(date) {
            var current_day = moment(date);

            while(disabled(new Date(current_day), 'day')) {
                current_day.add(1, 'day');
            }

            return current_day;
        }

        var getSkippedDays = function(start_date, end_date) {
            var current_day = moment(start_date);
            var end = getValidDate(end_date);
            var amount = 0;

            while(current_day.day() != end.day()) {
                if(disabled(new Date(current_day), 'day')) {
                    amount = amount + 1;
                }
                
                current_day.add(1, 'day');
            }

            return amount;
        }

        var separateTasks = function(tasks) {
            var new_tasks = [];
            _.each(tasks, function(task) {
                if(task.days > 1) {
                    var start = moment(task.start_date).clone();
                    for(var j=0; j<task.days; j++) {
                        var task_copy = angular.copy(task);
                        task_copy.start_date = new Date(start);
                        task_copy.end_date = new Date(start.clone().add(8, 'hours'));
                        task_copy.bid_hours = task_copy.bid_hours / task.days;
                        new_tasks.push(task_copy);

                        start = getValidDate(start.add(1, 'days'));
                    }
                } else {
                    new_tasks.push(task);
                }
            });

            return new_tasks;
        }

        var tasksForDialog = function(tasks, date) {
            var promises = [];
            var updated_tasks = $q.defer();

            tasks.forEach(function(task) {
                var in_list = $filter('filter')(promises, {'job_code': task.job_code,
                        'project_name': task.division.name}, true);

                if (moment(task.start_date).isSame(moment(date), 'day')) {
                    if(in_list.length === 0){
                        promises.push({
                            job_code: task.job_code,
                            project_name: task.division.name,
                            tasks: [task]
                        });
                    } else if(in_list.length === 1){
                        in_list[0].tasks.push(task);
                    }
                }
            });

            $q.all(promises).then(function(result) {
                updated_tasks.resolve(result);
            });

            return updated_tasks.promise;
        }

        var getEvents = function(tasks) {
            console.log('in the getEvents function');
            //some tasks can be more than one day.
            //go through the tasks list and break up
            //a task that goes over multiple days
            tasks = $filter('orderBy')(tasks, 'start_date');
            var full_tasks = [];

            // var phaseList = $filter('unique')(tasks, 'phase');
            // var phaseStr = '';
            // _.each(phaseList, function(item, idx) {
            //     phaseStr += item.phase;
            //     if(idx < phaseList.length-1) {
            //         phaseStr += ',';
            //     }
            // });

            // var taskList = $filter('unique')(tasks, 'task_code');
            // var taskStr = '';
            // _.each(taskList, function(item, idx) {
            //     taskStr += item.task_code;
            //     if(idx < taskList.length-1) {
            //         taskStr += ',';
            //     }
            // });

            _.each(tasks, function(task) {
                var days_skipped = getSkippedDays(task.start_date, task.end_date);
                var diff_days = moment(task.end_date).diff(moment(task.start_date), 'days');

                diff_days -= days_skipped;

                if(diff_days === 0) {
                    task.task_id = task._id;
                    full_tasks.push(task);
                } else {
                    diff_days += 1;
                    var new_start = moment(task.start_date).clone();
                    for(j=0; j<task.days; j++) {
                        var temp_task = [{
                            task_id: task._id,
                            bid_hours: task.bid_hours/task.days,
                            division: task.division,
                            end_date: new_start.clone().add(8, 'hours').format(),
                            job_code: task.job_code,
                            lot: task.lot,
                            phase: task.phase,
                            task_code: task.task_code,
                            start_date: new_start.clone().format(),
                            task_name: task.task_name
                        }];

                        // var array = task.task_code.split(',');
                        // if(array.indexOf(temp_task[0].task_code) === -1) {
                        //     array.push(temp_task[0].task_code);

                        //     var str = '';
                        //     _.each(array, function(item, idx) {
                        //         str += item;
                        //         if(idx < array.length-1) {
                        //             str += ',';
                        //         }
                        //     });

                        //     temp_task[0].task_code = str;
                        // }

                        // var array = task.phase.split(',');
                        // if(array.indexOf(temp_task[0].phase) === -1) {
                        //     array.push(temp_task[0].phase);

                        //     var str = '';
                        //     _.each(array, function(item, idx) {
                        //         str += item;
                        //         if(idx < array.length-1) {
                        //             str += ',';
                        //         }
                        //     });

                        //     temp_task[0].phase = str;
                        // }

                        console.log('adding ' + task.task_name + ' for lot ' +
                            task.lot + ' on date ' + new_start.format());

                        full_tasks.push(temp_task[0]);

                        new_start = moment(new_start).add(1, 'days');
                        new_start = getValidDate(new_start);
                    }
                }
            });

            var events = [];
            var current_day = moment(tasks[0].start_date);
            var show = [];
            var total_hours = 0;
            var count = 0;

            while(count < 50) {
                var in_list = $filter('filter')(full_tasks, {'start_date': current_day}, inRange);
                if(in_list.length > 0) {
                    var show = [];
                    var total_hours = 0;
                    var jobStrings = [];

                    var jobList = $filter('unique')(in_list, 'job_code');
                    _.each(jobList, function(job) {
                        var jobItems = $filter('filter')(in_list, {'job_code': job.job_code}, true);
                        
                        var phaseList = $filter('unique')(jobItems, 'phase');
                        var phaseStr = '';
                        _.each(phaseList, function(item, idx) {
                            phaseStr += item.phase;
                            if(idx < phaseList.length-1) {
                                phaseStr += ',';
                            }
                        });

                        var taskList = $filter('unique')(jobItems, 'task_code');
                        var taskStr = '';
                        _.each(taskList, function(item, idx) {
                            taskStr += item.task_code;
                            if(idx < taskList.length-1) {
                                taskStr += ',';
                            }
                        });

                        jobStrings.push({
                            'job_code': job.job_code,
                            'phaseStr': phaseStr,
                            'taskStr': taskStr
                        });
                    });

                    for(var j=0; j<in_list.length; j++) {
                        var item = $filter('filter')(show, {'job_code': in_list[j].job_code}, true);

                        if(item.length === 0) {
                            var phaseObj = $filter('filter')(jobStrings, {'job_code': in_list[j].job_code}, true)[0];
                            events.push({
                                title: in_list[j].job_code + ' - ' + in_list[j].division.name,
                                job_code: in_list[j].job_code,
                                start: moment(in_list[j].start_date),
                                end: moment(in_list[j].end_date),
                                hours: in_list[j].bid_hours,
                                lot: in_list[j].lot,
                                phase: in_list[j].phase,
                                phaseStr: phaseObj.phaseStr,
                                taskStr: phaseObj.taskStr,
                                task_code: in_list[j].task_code,
                                task_name: in_list[j].task_name,
                                project_id: in_list[j].project_id,
                                task_id: in_list[j].task_id,
                                textColor: '#000000',
                                day_of_year: moment().dayOfYear(in_list[j].start_date),
                                editable: false,
                                allDay: false,
                                stick: true
                            });

                            total_hours += in_list[j].bid_hours;

                            show.push({
                                job_code: in_list[j].job_code
                            });
                        } else {
                            var update = [];
                            update = $filter('filter')(events, {
                                'title': in_list[j].job_code + ' - ' + in_list[j].division.name,
                                'job_code': in_list[j].job_code}, true);


                            update.forEach(function(up) {
                                // var array = up.task_code.split(',');
                                // if(array.indexOf(in_list[j].task_code) === -1) {
                                //     array.push(in_list[j].task_code);

                                //     var str = '';
                                //     _.each(array, function(item, idx) {
                                //         str += item;
                                //         if(idx < array.length-1) {
                                //             str += ',';
                                //         }
                                //     });

                                //     in_list[j].task_code = str;
                                // }

                                // var array = up.phase.split(',');
                                // if(array.indexOf(in_list[j].phase) === -1) {
                                //     array.push(in_list[j].phase);

                                //     var str = '';
                                //     _.each(array, function(item, idx) {
                                //         str += item;
                                //         if(idx < array.length-1) {
                                //             str += ',';
                                //         }
                                //     });

                                //     in_list[j].phase = str;
                                // }

                                if(moment(up.start).diff(in_list[j].start_date) == 0) {
                                    up.hours += in_list[j].bid_hours;
                                    total_hours += in_list[j].bid_hours;
                                }
                            });
                        }
                        //console.log('current value of j ' + j + ' with start date vlaue ' + moment(in_list[j].start_date).format('MM/DD/YYYY : HH:mm:ss'));
                    }

                    //console.log('pushing on to events with value of j ' + j + ' for date ' + current_day.format('MM/DD/YYYY : HH:mm:ss'));
                    events.push({
                        title: 'Totals For Today: ',
                        job_code: full_tasks[j-1].job_code,
                        start: moment(current_day).clone(),
                        hours: total_hours,
                        editable: false,
                        allDay: true,
                        textColor: '#2E8B57',
                        backgroundColor: '#FFFFFF',
                        stick: true
                    });
                }

                count = count + 1;
                current_day.add(1, 'days');
            }

            return events;
        }

        return {
            setHolidaysArray: setHolidaysArray,
            disabled: disabled,
            getEvents: getEvents,
            separateTasks: separateTasks,
            tasksForDialog: tasksForDialog
        };
    }
]);


// WEBPACK FOOTER //
// ./packages/custom/foreman/public/services/foreman-calendar-service.js